<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Clientes/Colaboradores
            <router-link to="/app/sales/customer/">
              <l-button wide type="primary" round style="float: right; margin-right: 15px; margin-top: 5px">
                <span class="btn-label">
                  <i class="fa fa-plus"></i>
                </span>
                Criar
              </l-button>
            </router-link>
            <el-button icon="nc-icon nc-zoom-split"
              @click="filtro = true"
              class="pesquisa"
              circle
              style="font-size: 0.9em; float: right; margin-right: 15px"></el-button>

            <input
              style="display: none"
              type="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              @change="onFileChangedFile"
              ref="fileSelect">
            <el-button icon="fa fa-upload"
              :loading="btnLoading"
              style="font-size: 1em; float: right; margin-right: 15px"
              @click="$refs.fileSelect.click()"
              circle></el-button>
          </h4>
        </div>
        <el-dialog center :visible.sync="filtro" title="Filtros">
          <card class="row">
            <label class="col-sm-6">Nome</label>
              <el-autocomplete
                class="select-default col-sm-12"
                v-model="colabName"
                :fetch-suggestions="querySearchAsync"
                placeholder="Comece a digitar para pesquisar"
                @select="handleSelect"
              ></el-autocomplete>

            <label class="col-sm-6" style="margin-top: 15px" >Matricula</label>
              <el-autocomplete
                class="select-default col-sm-12"
                v-model="colabMatricula"
                :fetch-suggestions="querySearchAsyncMatricula"
                placeholder="Comece a digitar para pesquisar"
                @select="handleSelectMatricula"
              ></el-autocomplete>
          </card>
          <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
          <button class="btn btn-success" @click="filtragem()">Filtrar</button>
        </el-dialog>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
          <el-table-column type="expand">
            <template slot-scope="props">
              <p> <b>E-mail:</b>  {{ props.row.email }}  </p>
              <p> <b>Telefone:</b>  ({{ props.row.phone_area_code }})  {{props.row.phone_number}} </p>
              <p> <b>Código de acesso:</b>  {{ props.row.access_code }} </p>


            </template>
          </el-table-column>
            <el-table-column label="Colaborador" property="fullName" min-width="110" />
            <el-table-column label="Apelido" property="nickname" min-width="70" v-if="showMatriz" />
            <el-table-column label="Mátricula" property="registration" min-width="55"  />
            <el-table-column label="Ações" width="90" fixed="right">
              <div class="td-actions" slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                    <a
                    v-if="permission('edit_category')"
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                  <a
                  v-if="permission('delete_category')"
                  class="btn btn-danger btn-link btn-xs"
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-close"></i>
                </a>
                </el-tooltip>
              </div>
            </el-table-column>

          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next,total"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Dropdown,
  Button,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Select,
  DatePicker,
  TimeSelect,
  Option,
  Pagination,
  Tooltip,
  Tag,
  Loading,
  Autocomplete
} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Table.name]: Table,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
    [Autocomplete.name]: Autocomplete,
  },
  data() {
    return {
      companyList: [],
      search: '',
      loading: false,
      page: 1,
      filtro: false,
      pageSize: 10,
      btnLoading: false,
      totalResults: 30,
      customer: [],
      customerAPI: [],
      colabName: '',
      colabMatricula: '',
      pesquisa: '',
    };
  },
  computed: {
    tableData() {
      const customers = this.$store.state.customers.customers
      console.log('cust', customers)
      const populated = customers.map(v => {
        let company , fullName, nickname

        if (v.company) {
          company = this.companyList.find(e => e.profile__company__id == v.company);
        }
        if (v.first_name && v.last_name) {
          fullName = v.first_name + ' ' + v.last_name
        } else {
          fullName = v.first_name
        }
        if (v.nickname === null) {
          nickname = ''
        }
        if (v.nickname) {
          nickname = v.nickname
        }
        return { ...v, company, fullName, nickname };
      })
      return populated
    },

    getListCompany () {
      this.$store.dispatch("company/list")
    },

    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },

    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  created() {
  },
  mounted () {
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.getData(ciaID)
    } else {
      this.getData()
    }
    this.getListCompany
  },
  methods: {
    getData (id) {
      this.loading = true
      if (id) {
        id = id
      } else {
        id = ''
      }
      this.$store.dispatch("customers/listSort", {sort: '?page_size=' + this.pageSize
        + '&page=' + this.page + '&company=' + id + this.pesquisa}).then(resp => {
        this.totalResults = this.$store.state.customers.page.count
        console.log('rest', resp)
        console.log('store', this.$store.state)
        this.customer = resp
        this.customerAPI = resp
        this.loading = false
        this.tableData
      }).catch(err => console.log(err));
    },

    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === "data_inicio") {
        x.prop = 'start_date'
      }
      if (x.prop === 'data_fim') {
        x.prop = 'end_date'
      }
      this.sord = sinal + x.prop
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/sales/customer/${row.id}`);
    },
    // getListCompany () {
    //   this.$store.dispatch('general/listUser').then(()=> {
    //     var x = this.$store.state.general.listUser.user_list_info
    //     this.companyList = x.filter((thing, index, self) =>
    //       index === self.findIndex((t) => (
    //         t.profile__company__id === thing.profile__company__id && t.profile__company__name === thing.profile__company__name
    //       ))
    //     )
    //   })
    // },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },

    permission(permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(
        el => {
          if (el == permissao) {
            return true;
          }
        }
      );
      if (x.length > 0) {
        return true;
      }
      if (localStorage.getItem("parent_company")) {
        return true
      }
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = "Cliente";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("customers/delete", { id: row.id });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },

    onFileChangedFile (event) {
      this.btnLoading = true
      this.$store.dispatch("customers/createForm",
          { item: event.target.files[0], name: event.target.files[0].name }).then(resp =>{
          console.log('resp', resp)
        this.btnLoading = false
        this.text = 'Arquivo enviado com sucesso'
        this.color = 'success'
        this.snackbar = true
      }).catch(err => {
        this.text = 'Falha ao enviar o arquivo'
        this.color = 'error'
        this.snackbar = true
        this.btnLoading = false
      })
    },

    querySearchAsync(queryString, cb) {
      var y
      this.$store.dispatch("customers/listSort", {sort: '?first_name__icontains=' + queryString}).then(data => {
        var x = data.map(v => {
          let value, link
          if (v.first_name) {
            value = v.first_name
          }
          link = value
          return {...v, value, link}

        })
        console.log('pesq', y)
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results

        results = queryString ? links.filter(this.createFilter(queryString)) : links;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },

    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.colabName = item.first_name
      this.model.customer = item.id
      console.log('selec', item);
    },
    redux(x) {
      var seenNumber = {};

      var fil = x.filter(function(
        currentObject
      ) {
        if (currentObject.status in seenNumber) {
          return false;
        } else {
          seenNumber[currentObject.status] = true;
          return true;
        }
      });
      return fil;
    },


    querySearchAsyncMatricula(queryString, cb) {
      var y
      this.$store.dispatch("customers/listSort", {sort: '?registration__icontains=' + queryString}).then(data => {
        var x = data.map(v => {
          let value, link
          if (v.registration) {
            value = v.registration
          }
          link = value
          return {...v, value, link}

        })
        console.log('pesq', y)
        y = this.redux(x)
        this.links = y
        var links = this.links;
        var results

        results = queryString ? links.filter(this.createFilter(queryString)) : links;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 600);
        })
    },
    handleSelectMatricula(item) {
      this.colabMatricula = item.registration
      this.model.customer = item.id
      console.log('selec', item);
    },

    clearFiltro() {
      this.colabName = "";
      this.colabMatricula = ''
      this.filtro = false;
      this.page = 1
      this.pesquisa = ''
      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },

    filtragem () {
      this.customer = this.customerAPI
      this.pesquisa = ''
      console.log('name', this.colabName)
      console.log('matricula', this.colabMatricula)
      if (this.colabName) {
        this.pesquisa = this.pesquisa + '&first_name__icontains=' + this.colabName
      }
      if (this.colabMatricula) {
        this.pesquisa = this.pesquisa + '&registration=' + this.colabMatricula
      }

      const ciaID = localStorage.getItem('smartmachCiaID')
      if (ciaID) {
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.filtro = false;
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
.el-pagination__total {
    float: right;
    text-align: end;
    font-weight: 400;
    color: #606266;
}
.pesquisa {
    font-size: 0.9em;
    float: right;
    margin-right: 15px;
}
</style>
querySearchAsync
